import React from 'react'
import { BiDollar } from 'react-icons/bi'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Core Banking Systems', description: 'Support secure deposits, accounts, transactions, and operations.' },
    { title: 'Microfinance Platforms', description: 'Manage customers, groups, loans, repayments, and reporting.' },
    { title: 'SACCO Management', description: 'Digitize member accounts, savings, loans, and approvals.' },
    { title: 'Savings & Loans Systems', description: 'Handle lending workflows, balances, statements, and collections.' },
    { title: 'Payment Gateway Integration', description: 'Connect secure online payment channels to your platforms.' },
    { title: 'Mobile Money Integration', description: 'Enable mobile wallet deposits, payments, and collections.' },
    { title: 'Digital Wallets', description: 'Support stored value, transfers, payments, and user balances.' },
    { title: 'Loan Management', description: 'Track applications, scoring, disbursement, repayment, and arrears.' },
    { title: 'Financial Analytics', description: 'Improve reporting, portfolio visibility, and decision-making.' }
]

const FinancialTechnologySolutions = () => (
    <TechnologyServicePage
        badge="Financial Technology Solutions"
        title="Secure financial platforms for payments, lending, and analytics."
        description="We deliver fintech systems for banking, microfinance, SACCOs, savings and loans, mobile money, wallets, payments, and financial reporting."
        metaDescription="Financial technology solutions for core banking, microfinance, SACCOs, savings and loans, payment gateways, mobile money, wallets, loans, and analytics."
        icon={<BiDollar className="text-sm" />}
        capabilities={capabilities}
        outcomes={[
            { title: 'Secure transactions', description: 'Support financial activity with reliable, controlled digital systems.' },
            { title: 'Faster lending', description: 'Digitize loan workflows from application to repayment tracking.' },
            { title: 'Clear financial insight', description: 'Use analytics to understand portfolio health and performance.' }
        ]}
        highlights={[
            { title: 'Transact', description: 'Enable payments, mobile money, wallets, and gateway integrations.' },
            { title: 'Lend', description: 'Manage savings, loans, applications, disbursement, and collections.' },
            { title: 'Analyze', description: 'Turn financial data into useful reports and dashboards.' }
        ]}
        cta={{
            eyebrow: 'Fintech with confidence',
            title: 'Build secure digital finance experiences that scale.',
            description: 'We help financial organizations improve access, control, and reporting through modern platforms.'
        }}
    />
)

export default FinancialTechnologySolutions
